import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CenSelectedArticleTypeState from "@tCentro/Store/Reducer/CenSelectedArticleTypeState";
import { Draft } from "immer";

const initialState: CenSelectedArticleTypeState = {
    selectedArticleType:"allArticlesType" ,
};
export default createTypedReducerWithImmer(initialState, {
    "Custom/Article/SetSelectedArticleType": (
        draft: Draft<CenSelectedArticleTypeState>,
        action: { selectedArticleType: string },
    ) => {
        draft.selectedArticleType = action.selectedArticleType;
    },
});
